export function formatIndianNumber(number) {
  // Convert the number to a string
  let numStr = number.toString();

  // Split the number into integer and decimal parts
  let [integerPart, decimalPart] = numStr.split(".");

  // Handle the integer part
  let lastThreeDigits = integerPart.slice(-3);
  let otherDigits = integerPart.slice(0, -3);

  if (otherDigits !== "") {
    // Add commas to the remaining part in chunks of two
    otherDigits = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
    return (
      otherDigits +
      "," +
      lastThreeDigits +
      (decimalPart ? "." + decimalPart : "")
    );
  } else {
    return lastThreeDigits + (decimalPart ? "." + decimalPart : "");
  }
}
